// @credit: 76a97b1cd4349534e19fb23cf80c4a0f1b1502418015de1e9d68b95c44bc36d433ed49b8
//
// Aphilaty PWA — App Router

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './styles/global.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import AppShell from './components/AppShell';
import LoginPage from './pages/LoginPage';
import RequestOrgAccessPage from './pages/RequestOrgAccess';
import ActivateAdminInvitePage from './pages/ActivateAdminInvite';
import DashboardPage from './pages/dashboard/DashboardPage';
import AddOfferPage from './pages/offers/AddOfferPage';
import {
  ItemSummaryPage, ItemDetailPage,
  InventoryDetailPage, OfferPerformancePage,
} from './pages/analytics/AnalyticsPages';
import {
  MessagesPage, SettingsPage,
} from './pages/messages/MessagesAndSettingsPages';
import { EventsPage } from './pages/events/EventsPage';
import { PlatformAdminPage } from './pages/admin/PlatformAdminPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: 'var(--color-secondary)' }}>
      <span className="spinner" />
    </div>
  );
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function PlatformAdminRoute({ children }: { children: React.ReactNode }) {
  const { isPlatformAdmin, isLoading } = useAuth();
  if (isLoading) return null;
  return isPlatformAdmin ? <>{children}</> : <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename="/admin">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/request-access" element={<RequestOrgAccessPage />} />
          <Route path="/activate" element={<ActivateAdminInvitePage />} />

          <Route path="/" element={
            <ProtectedRoute><AppShell /></ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />

            {/* Offers */}
            <Route path="offers" element={<AddOfferPage />} />
            <Route path="offers/new" element={<AddOfferPage />} />
            <Route path="offers/drafts" element={<AddOfferPage />} />

            {/* Analytics */}
            <Route path="analytics/items" element={<ItemSummaryPage />} />
            <Route path="analytics/items/detail" element={<ItemDetailPage />} />
            <Route path="analytics/inventory" element={<InventoryDetailPage />} />
            <Route path="analytics/offers" element={<OfferPerformancePage />} />

            {/* Messages */}
            <Route path="messages" element={<MessagesPage />} />

            {/* Events */}
            <Route path="events" element={<EventsPage />} />

            {/* Platform Admin */}
            <Route path="admin/platform" element={
              <PlatformAdminRoute><PlatformAdminPage /></PlatformAdminRoute>
            } />

            {/* Settings */}
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
